// import React, { useEffect } from "react";
// import { useNewsletterForm } from "./contexts/NewsletterFormContext";
// import { useCategories } from "../../../lib/firebase/category/read";
// import { useSearchParams, Link } from "react-router-dom";
// import { Form, Button, Row, Col, Alert, Spinner } from "react-bootstrap";

// function FormPage() {
//   const [searchParams] = useSearchParams();
//   const updateNewsletterId = searchParams.get("id");

//   const {
//     data,
//     handleData,
//     isUpdateLoading,
//     isDeleteLoading,
//     successMessage,
//     error,
//     handleCreate,
//     handleUpdate,
//     handleDelete,
//     fetchData,
//     isFetching,
//     resetForm,
//     validationErrors,
//   } = useNewsletterForm();

//   const { data: categories } = useCategories();

//   useEffect(() => {
//     if (!updateNewsletterId) {
//       resetForm();
//       handleData("productType", "Newsletter");
//     } else {
//       fetchData(updateNewsletterId, "Newsletter");
//     }
//   }, [updateNewsletterId, fetchData, resetForm, handleData]);

//   return (
//     <main className="py-2">
//       <div className="mb-3 d-flex justify-content-between align-items-center">
//         {updateNewsletterId ? (
//           <span className="badge bg-warning text-dark">Update</span>
//         ) : (
//           <span className="badge bg-success text-white">Create</span>
//         )}
//         <h1 className="h4">Newsletters | Form</h1>
//         <Link to="/admin/newsletters" className="btn btn-secondary">
//           Back to Newsletters
//         </Link>
//       </div>

//       <section>
//         <Form
//           onSubmit={(e) => {
//             e.preventDefault();
//             if (updateNewsletterId) {
//               handleUpdate("Newsletter");
//             } else {
//               handleCreate("Newsletter");
//             }
//           }}
//           className="p-4 bg-light rounded shadow-sm"
//           noValidate
//         >
//           {successMessage && (
//             <Alert variant="success" className="text-center">
//               {successMessage}
//             </Alert>
//           )}
//           {error && (
//             <Alert variant="danger" className="text-center">
//               {error}
//             </Alert>
//           )}
//           {isFetching && (
//             <div className="text-center py-4">
//               <Spinner animation="border" />
//             </div>
//           )}

//           {!isFetching && (
//             <div className="mb-4">
//               <h5>Newsletter Details</h5>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Publication Name <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="Enter Publication Name"
//                       type="text"
//                       value={data?.publicationName || ""}
//                       onChange={(e) =>
//                         handleData("publicationName", e.target.value)
//                       }
//                       required
//                       className={
//                         validationErrors.publicationName ? "is-invalid" : ""
//                       }
//                     />
//                     {validationErrors.publicationName && (
//                       <div className="invalid-feedback">
//                         {validationErrors.publicationName}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Article Title <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="Enter Article Title"
//                       type="text"
//                       value={data?.articleTitle || ""}
//                       onChange={(e) =>
//                         handleData("articleTitle", e.target.value)
//                       }
//                       required
//                       className={
//                         validationErrors.articleTitle ? "is-invalid" : ""
//                       }
//                     />
//                     {validationErrors.articleTitle && (
//                       <div className="invalid-feedback">
//                         {validationErrors.articleTitle}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Volume <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="e.g., 6(8)"
//                       type="text"
//                       value={data?.volume || ""}
//                       onChange={(e) => handleData("volume", e.target.value)}
//                       required
//                       className={validationErrors.volume ? "is-invalid" : ""}
//                     />
//                     {validationErrors.volume && (
//                       <div className="invalid-feedback">
//                         {validationErrors.volume}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Days of Publication <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="e.g., 26 August, 2025 or August, 2025 or Mar/Apr, 2025"
//                       type="text"
//                       value={data?.daysOfPublication || ""}
//                       onChange={(e) =>
//                         handleData("daysOfPublication", e.target.value)
//                       }
//                       required
//                       className={
//                         validationErrors.daysOfPublication ? "is-invalid" : ""
//                       }
//                     />
//                     {validationErrors.daysOfPublication && (
//                       <div className="invalid-feedback">
//                         {validationErrors.daysOfPublication}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Meta Title <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="Enter Meta Title"
//                       type="text"
//                       onChange={(e) => handleData("metaTitle", e.target.value)}
//                       value={data?.metaTitle || ""}
//                       required
//                       className={validationErrors.metaTitle ? "is-invalid" : ""}
//                     />
//                     {validationErrors.metaTitle && (
//                       <div className="invalid-feedback">
//                         {validationErrors.metaTitle}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Meta Description <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="Enter Meta Description"
//                       type="text"
//                       onChange={(e) =>
//                         handleData("metaDescription", e.target.value)
//                       }
//                       value={data?.metaDescription || ""}
//                       required
//                       className={
//                         validationErrors.metaDescription ? "is-invalid" : ""
//                       }
//                     />
//                     {validationErrors.metaDescription && (
//                       <div className="invalid-feedback">
//                         {validationErrors.metaDescription}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Category ID <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Select
//                       value={data?.categoryId || ""}
//                       onChange={(e) => handleData("categoryId", e.target.value)}
//                       required
//                       className={
//                         validationErrors.categoryId ? "is-invalid" : ""
//                       }
//                     >
//                       <option value="">Select Category</option>
//                       {categories?.map((item) => (
//                         <option key={item?.id} value={item?.id}>
//                           {item?.name}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {validationErrors.categoryId && (
//                       <div className="invalid-feedback">
//                         {validationErrors.categoryId}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       PDF{" "}
//                       <span className="text-danger">
//                         {updateNewsletterId ? "" : "*"}
//                       </span>
//                     </Form.Label>
//                     <Form.Control
//                       type="file"
//                       accept="application/pdf"
//                       onChange={(e) => handleData("pdfFile", e.target.files[0])}
//                       required={!data.pdfUrl}
//                       className={validationErrors.pdfFile ? "is-invalid" : ""}
//                     />
//                     {validationErrors.pdfFile && (
//                       <div className="invalid-feedback">
//                         {validationErrors.pdfFile}
//                       </div>
//                     )}
//                     {data.pdfFile && (
//                       <div className="mt-2 text-muted">
//                         Uploaded: {data.pdfFile.name}
//                       </div>
//                     )}
//                     {data.pdfUrl && (
//                       <div className="mt-2">
//                         <a
//                           href={data.pdfUrl}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           View Current PDF
//                         </a>
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </div>
//           )}

//           <div className="d-flex gap-3">
//             <Button
//               type="submit"
//               disabled={isFetching || isUpdateLoading || isDeleteLoading}
//               variant="primary"
//               className="w-100"
//             >
//               {isUpdateLoading
//                 ? updateNewsletterId
//                   ? "Updating..."
//                   : "Creating..."
//                 : updateNewsletterId
//                 ? "Update"
//                 : "Create"}
//             </Button>
//             {updateNewsletterId && (
//               <Button
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleDelete(updateNewsletterId, "Newsletter");
//                 }}
//                 disabled={isFetching || isUpdateLoading || isDeleteLoading}
//                 variant="danger"
//                 className="w-100"
//               >
//                 {isDeleteLoading ? "Deleting..." : "Delete"}
//               </Button>
//             )}
//           </div>
//         </Form>
//       </section>
//     </main>
//   );
// }

// export default FormPage;

// import React, { useEffect } from "react";
// import { useNewsletterForm } from "./contexts/NewsletterFormContext";
// import { useCategories } from "../../../lib/firebase/category/read";
// import { useSearchParams, Link } from "react-router-dom";
// import { Form, Button, Row, Col, Alert, Spinner } from "react-bootstrap";

// function FormPage() {
//   const [searchParams] = useSearchParams();
//   const updateNewsletterId = searchParams.get("id");

//   const {
//     data,
//     handleData,
//     isUpdateLoading,
//     isDeleteLoading,
//     successMessage,
//     error,
//     handleCreate,
//     handleUpdate,
//     handleDelete,
//     fetchData,
//     isFetching,
//     resetForm,
//     validationErrors,
//   } = useNewsletterForm();

//   const { data: categories } = useCategories();

//   useEffect(() => {
//     if (!updateNewsletterId) {
//       resetForm();
//       handleData("productType", "Newsletter");
//     } else {
//       fetchData(updateNewsletterId, "Newsletter");
//     }
//   }, [updateNewsletterId, fetchData, resetForm, handleData]);

//   return (
//     <main className="py-2">
//       <div className="mb-3 d-flex justify-content-between align-items-center">
//         {updateNewsletterId ? (
//           <span className="badge bg-warning text-dark">Update</span>
//         ) : (
//           <span className="badge bg-success text-white">Create</span>
//         )}
//         <h1 className="h4">Newsletters | Form</h1>
//         <Link to="/admin/newsletters" className="btn btn-secondary">
//           Back to Newsletters
//         </Link>
//       </div>

//       <section>
//         <Form
//           onSubmit={(e) => {
//             e.preventDefault();
//             if (updateNewsletterId) {
//               handleUpdate("Newsletter");
//             } else {
//               handleCreate("Newsletter");
//             }
//           }}
//           className="p-4 bg-light rounded shadow-sm"
//           noValidate
//         >
//           {successMessage && (
//             <Alert variant="success" className="text-center">
//               {successMessage}
//             </Alert>
//           )}
//           {error && (
//             <Alert variant="danger" className="text-center">
//               {error}
//             </Alert>
//           )}
//           {isFetching && (
//             <div className="text-center py-4">
//               <Spinner animation="border" />
//             </div>
//           )}

//           {!isFetching && (
//             <div className="mb-4">
//               <h5>Newsletter Details</h5>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Publication Name <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="Enter Publication Name"
//                       type="text"
//                       value={data?.publicationName || ""}
//                       onChange={(e) =>
//                         handleData("publicationName", e.target.value)
//                       }
//                       required
//                       className={
//                         validationErrors.publicationName ? "is-invalid" : ""
//                       }
//                     />
//                     {validationErrors.publicationName && (
//                       <div className="invalid-feedback">
//                         {validationErrors.publicationName}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Article Title <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="Enter Article Title"
//                       type="text"
//                       value={data?.articleTitle || ""}
//                       onChange={(e) =>
//                         handleData("articleTitle", e.target.value)
//                       }
//                       required
//                       className={
//                         validationErrors.articleTitle ? "is-invalid" : ""
//                       }
//                     />
//                     {validationErrors.articleTitle && (
//                       <div className="invalid-feedback">
//                         {validationErrors.articleTitle}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Volume <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="e.g., 6(8)"
//                       type="text"
//                       value={data?.volume || ""}
//                       onChange={(e) => handleData("volume", e.target.value)}
//                       required
//                       className={validationErrors.volume ? "is-invalid" : ""}
//                     />
//                     {validationErrors.volume && (
//                       <div className="invalid-feedback">
//                         {validationErrors.volume}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Days of Publication <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="e.g., 26 August, 2025 or August, 2025 or Mar/Apr, 2025"
//                       type="text"
//                       value={data?.daysOfPublication || ""}
//                       onChange={(e) =>
//                         handleData("daysOfPublication", e.target.value)
//                       }
//                       required
//                       className={
//                         validationErrors.daysOfPublication ? "is-invalid" : ""
//                       }
//                     />
//                     {validationErrors.daysOfPublication && (
//                       <div className="invalid-feedback">
//                         {validationErrors.daysOfPublication}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Shooting Date <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       type="date"
//                       value={data?.shootingDate || ""}
//                       onChange={(e) =>
//                         handleData("shootingDate", e.target.value)
//                       }
//                       required
//                       className={
//                         validationErrors.shootingDate ? "is-invalid" : ""
//                       }
//                     />
//                     {validationErrors.shootingDate && (
//                       <div className="invalid-feedback">
//                         {validationErrors.shootingDate}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Meta Title <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="Enter Meta Title"
//                       type="text"
//                       value={data?.metaTitle || ""}
//                       onChange={(e) => handleData("metaTitle", e.target.value)}
//                       required
//                       className={validationErrors.metaTitle ? "is-invalid" : ""}
//                     />
//                     {validationErrors.metaTitle && (
//                       <div className="invalid-feedback">
//                         {validationErrors.metaTitle}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Meta Description <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       placeholder="Enter Meta Description"
//                       type="text"
//                       value={data?.metaDescription || ""}
//                       onChange={(e) =>
//                         handleData("metaDescription", e.target.value)
//                       }
//                       required
//                       className={
//                         validationErrors.metaDescription ? "is-invalid" : ""
//                       }
//                     />
//                     {validationErrors.metaDescription && (
//                       <div className="invalid-feedback">
//                         {validationErrors.metaDescription}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       Category ID <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Select
//                       value={data?.categoryId || ""}
//                       onChange={(e) => handleData("categoryId", e.target.value)}
//                       required
//                       className={
//                         validationErrors.categoryId ? "is-invalid" : ""
//                       }
//                     >
//                       <option value="">Select Category</option>
//                       {categories?.map((item) => (
//                         <option key={item?.id} value={item?.id}>
//                           {item?.name}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {validationErrors.categoryId && (
//                       <div className="invalid-feedback">
//                         {validationErrors.categoryId}
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>
//                       PDF{" "}
//                       <span className="text-danger">
//                         {updateNewsletterId ? "" : "*"}
//                       </span>
//                     </Form.Label>
//                     <Form.Control
//                       type="file"
//                       accept="application/pdf"
//                       onChange={(e) => handleData("pdfFile", e.target.files[0])}
//                       required={!data.pdfUrl}
//                       className={validationErrors.pdfFile ? "is-invalid" : ""}
//                     />
//                     {validationErrors.pdfFile && (
//                       <div className="invalid-feedback">
//                         {validationErrors.pdfFile}
//                       </div>
//                     )}
//                     {data.pdfFile && (
//                       <div className="mt-2 text-muted">
//                         Uploaded: {data.pdfFile.name}
//                       </div>
//                     )}
//                     {data.pdfUrl && (
//                       <div className="mt-2">
//                         <a
//                           href={data.pdfUrl}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           View Current PDF
//                         </a>
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </div>
//           )}

//           <div className="d-flex gap-3">
//             <Button
//               type="submit"
//               disabled={isFetching || isUpdateLoading || isDeleteLoading}
//               variant="primary"
//               className="w-100"
//             >
//               {isUpdateLoading
//                 ? updateNewsletterId
//                   ? "Updating..."
//                   : "Creating..."
//                 : updateNewsletterId
//                 ? "Update"
//                 : "Create"}
//             </Button>
//             {updateNewsletterId && (
//               <Button
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleDelete(updateNewsletterId, "Newsletter");
//                 }}
//                 disabled={isFetching || isUpdateLoading || isDeleteLoading}
//                 variant="danger"
//                 className="w-100"
//               >
//                 {isDeleteLoading ? "Deleting..." : "Delete"}
//               </Button>
//             )}
//           </div>
//         </Form>
//       </section>
//     </main>
//   );
// }

// export default FormPage;

import React, { useEffect } from "react";
import { useNewsletterForm } from "./contexts/NewsletterFormContext";
import { useCategories } from "../../../lib/firebase/category/read";
import { useSearchParams, Link } from "react-router-dom";
import { Form, Button, Row, Col, Alert, Spinner } from "react-bootstrap";

function FormPage() {
  const [searchParams] = useSearchParams();
  const updateNewsletterId = searchParams.get("id");

  const {
    data,
    handleData,
    isUpdateLoading,
    isDeleteLoading,
    successMessage,
    error,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    isFetching,
    resetForm,
    validationErrors,
  } = useNewsletterForm();

  const { data: categories } = useCategories();

  useEffect(() => {
    if (!updateNewsletterId) {
      resetForm();
      handleData("productType", "Newsletter");
    } else {
      fetchData(updateNewsletterId, "Newsletter");
    }
  }, [updateNewsletterId, fetchData, resetForm, handleData]);

  return (
    <main className="py-2">
      <div className="mb-3 d-flex justify-content-between align-items-center">
        {updateNewsletterId ? (
          <span className="badge bg-warning text-dark">Update</span>
        ) : (
          <span className="badge bg-success text-white">Create</span>
        )}
        <h1 className="h4">Newsletters | Form</h1>
        <Link to="/admin/newsletters" className="btn btn-secondary">
          Back to Newsletters
        </Link>
      </div>

      <section>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            if (updateNewsletterId) {
              handleUpdate("Newsletter");
            } else {
              handleCreate("Newsletter");
            }
          }}
          className="p-4 bg-light rounded shadow-sm"
          noValidate
        >
          {successMessage && (
            <Alert variant="success" className="text-center">
              {successMessage}
            </Alert>
          )}
          {error && (
            <Alert variant="danger" className="text-center">
              {error}
            </Alert>
          )}
          {isFetching && (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          )}

          {!isFetching && (
            <div className="mb-4">
              <h5>Newsletter Details</h5>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Publication Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder="Enter Publication Name"
                      type="text"
                      value={data?.publicationName || ""}
                      onChange={(e) =>
                        handleData("publicationName", e.target.value)
                      }
                      required
                      className={
                        validationErrors.publicationName ? "is-invalid" : ""
                      }
                    />
                    {validationErrors.publicationName && (
                      <div className="invalid-feedback">
                        {validationErrors.publicationName}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Article Title <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder="Enter Article Title"
                      type="text"
                      value={data?.articleTitle || ""}
                      onChange={(e) =>
                        handleData("articleTitle", e.target.value)
                      }
                      required
                      className={
                        validationErrors.articleTitle ? "is-invalid" : ""
                      }
                    />
                    {validationErrors.articleTitle && (
                      <div className="invalid-feedback">
                        {validationErrors.articleTitle}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Volume <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder="e.g., 6(8)"
                      type="text"
                      value={data?.volume || ""}
                      onChange={(e) => handleData("volume", e.target.value)}
                      required
                      className={validationErrors.volume ? "is-invalid" : ""}
                    />
                    {validationErrors.volume && (
                      <div className="invalid-feedback">
                        {validationErrors.volume}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Days of Publication <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder="e.g., 26 August, 2025 or August, 2025 or Mar/Apr, 2025"
                      type="text"
                      value={data?.daysOfPublication || ""}
                      onChange={(e) =>
                        handleData("daysOfPublication", e.target.value)
                      }
                      required
                      className={
                        validationErrors.daysOfPublication ? "is-invalid" : ""
                      }
                    />
                    {validationErrors.daysOfPublication && (
                      <div className="invalid-feedback">
                        {validationErrors.daysOfPublication}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Sorted Date <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={data?.sortedDate || ""}
                      onChange={(e) => handleData("sortedDate", e.target.value)}
                      required
                      className={
                        validationErrors.sortedDate ? "is-invalid" : ""
                      }
                    />
                    {validationErrors.sortedDate && (
                      <div className="invalid-feedback">
                        {validationErrors.sortedDate}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Meta Title <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder="Enter Meta Title"
                      type="text"
                      value={data?.metaTitle || ""}
                      onChange={(e) => handleData("metaTitle", e.target.value)}
                      required
                      className={validationErrors.metaTitle ? "is-invalid" : ""}
                    />
                    {validationErrors.metaTitle && (
                      <div className="invalid-feedback">
                        {validationErrors.metaTitle}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Meta Description <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder="Enter Meta Description"
                      type="text"
                      value={data?.metaDescription || ""}
                      onChange={(e) =>
                        handleData("metaDescription", e.target.value)
                      }
                      required
                      className={
                        validationErrors.metaDescription ? "is-invalid" : ""
                      }
                    />
                    {validationErrors.metaDescription && (
                      <div className="invalid-feedback">
                        {validationErrors.metaDescription}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Category ID <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={data?.categoryId || ""}
                      onChange={(e) => handleData("categoryId", e.target.value)}
                      required
                      className={
                        validationErrors.categoryId ? "is-invalid" : ""
                      }
                    >
                      <option value="">Select Category</option>
                      {categories?.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Form.Select>
                    {validationErrors.categoryId && (
                      <div className="invalid-feedback">
                        {validationErrors.categoryId}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      PDF{" "}
                      <span className="text-danger">
                        {updateNewsletterId ? "" : "*"}
                      </span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="application/pdf"
                      onChange={(e) => handleData("pdfFile", e.target.files[0])}
                      required={!data.pdfUrl}
                      className={validationErrors.pdfFile ? "is-invalid" : ""}
                    />
                    {validationErrors.pdfFile && (
                      <div className="invalid-feedback">
                        {validationErrors.pdfFile}
                      </div>
                    )}
                    {data.pdfFile && (
                      <div className="mt-2 text-muted">
                        Uploaded: {data.pdfFile.name}
                      </div>
                    )}
                    {data.pdfUrl && (
                      <div className="mt-2">
                        <a
                          href={data.pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Current PDF
                        </a>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
          )}

          <div className="d-flex gap-3">
            <Button
              type="submit"
              disabled={isFetching || isUpdateLoading || isDeleteLoading}
              variant="primary"
              className="w-100"
            >
              {isUpdateLoading
                ? updateNewsletterId
                  ? "Updating..."
                  : "Creating..."
                : updateNewsletterId
                ? "Update"
                : "Create"}
            </Button>
            {updateNewsletterId && (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleDelete(updateNewsletterId, "Newsletter");
                }}
                disabled={isFetching || isUpdateLoading || isDeleteLoading}
                variant="danger"
                className="w-100"
              >
                {isDeleteLoading ? "Deleting..." : "Delete"}
              </Button>
            )}
          </div>
        </Form>
      </section>
    </main>
  );
}

export default FormPage;
